import { render, staticRenderFns } from "./alertList.vue?vue&type=template&id=690d3c80&scoped=true"
import script from "./alertList.vue?vue&type=script&lang=js"
export * from "./alertList.vue?vue&type=script&lang=js"
import style0 from "./alertList.vue?vue&type=style&index=0&id=690d3c80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690d3c80",
  null
  
)

export default component.exports